import React, {ReactNode} from "react";
import {AxiosError} from "axios";
import {isEmptyObject} from "./fns";
import {Button, Divider, Modal} from "antd";
import {MessageInstance} from "antd/es/message/interface";

type TErrorToast = {
    [key: string]: {
        detail: {
            toast: string;
            code: string[];
        }
    }
}

type TErrorItem = {
    code: string;
    field: "toast" | "ui.title" | "ui.text" | "ui.button.ok" | "ui.button.cancel";
    message: string | {
        message: string
    };
}

export type TApiError = {
    errors?: any[],
    message?: string;
    detail?: string;
};

export const showApiError = (error: AxiosError<TApiError> | any, message: MessageInstance) => {
    const errors = error.response?.data?.errors || error.response?.data;
    console.log("apiError", errors);
    let popup: any = {};
    let fieldError: any = {};
    if (errors && Array.isArray(errors)) {
        errors.forEach((e: TErrorItem | TErrorToast) => {
            if (e.field) {
                switch (e.field) {
                    case "toast":
                        fieldError.field = "";
                        fieldError.message = e.message + "";
                        return;
                    case "ui.title":
                        popup.title = e.message;
                        break;
                    case "ui.text":
                        popup.content = e.message;
                        break;
                    case "ui.button.ok":
                        popup.btnOk = e.message;
                        break;
                    case "ui.button.cancel":
                        popup.btnCancel = e.message;
                        break;
                    default:
                        fieldError.field = e.field;
                        fieldError.message = e.message.toString();
                }
            } else if (e.message) {
                fieldError.field = ""
                fieldError.message = e.message.toString();
            } else {
                const errortoast = e as TErrorToast
                const key = Object.keys(e)[0] as string;
                if (errortoast[key].detail) {
                    const messageString = errortoast[key]?.detail?.toast
                    console.log("apiError toast", errortoast[key]);
                    fieldError.field = "";
                    fieldError.message = messageString;
                }
            }
        });
        if (!isEmptyObject(popup)) {
            showMessageWithTitle(popup.content);
            return;
        } else if (!isEmptyObject(fieldError)) {
            showMessage(message, fieldError.field + fieldError.message);
        }
    } else if (error?.response?.data && Array.isArray(error?.response?.data) && error?.response?.data.length > 0) {
        let messageString = "";
        error?.response?.data.forEach((e: any) => {
            messageString = JSON.stringify(e);
        });
        showMessage(message, messageString);
    } else {
        showMessage(message, error?.response?.data?.detail || error?.response?.data || error.message);
    }
};

export const showMessage = (message: MessageInstance, content: string | ReactNode, type: "info" | "success" | "error" | "warning" | "loading" = "warning", duration = 2) => {
    message.open({
        className: "message", type, content: <span className={"text"}>{content}</span>, duration,
    })
        .then(() => {
            console.log("showMessage")
        })
};

export const showMessageWithTitle = (content: string | ReactNode, onOk?: () => void) => {
    const hide = () => {
        Modal.destroyAll()
    }

    const onClickOk = () => {
        if (onOk) onOk()
        hide();
    }

    const footer = (<div className={"footer"}>
        {!!onOk && (<>
            <Button type={"text"} className={"cancel"} onClick={hide}>취소</Button>
            <Divider type={"vertical"} className={"divider"}/>
        </>)}
        <Button type={"text"} className={"cancel"} onClick={onClickOk}>확인</Button>
    </div>)

    Modal.confirm({
        icon: <div/>,
        closable: false,
        width: 280,
        rootClassName: "sm-modal",
        classNames: {content: "content", footer: "footer"},
        centered: true,
        footer,
        content: <div className={"body"}>
            <div className={"title"}>알림</div>
            <div className={"label"}>{content}</div>
        </div>,
    });
};
